import anime from 'animejs';

export default class FullscreenPicture {
  constructor(root) {
    if (!root) {
      return;
    }

    this.root = root;
    this.img = this.root.querySelector('.u-mosaic__picture__img');
    this.src = this.img.src;
    this.srcset = this.img.srcset;
    this.link = this.root.querySelector('.u-mosaic__picture__link');

    // if the picture is already inside an overlayer, we need to
    // retrieve to set its overflow to hidden
    this.overlayerParent = document.querySelector('.u-mosaic-overlayer');

    this.overlayer = null;

    this.bind();
  }

  bind() {
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);
    this.createElement = this.createElement.bind(this);

    this.link.addEventListener('click', this.open);
    window.addEventListener('keyup', this.onKeyUp);
  }

  open(e) {
    e.preventDefault();
    e.stopPropagation();

    if (this.isOpen) {
      return;
    }

    document.body.classList.add('no-scroll');

    if (this.overlayerParent) {
      this.overlayerParent.style.overflow = 'hidden';
    }

    this.createElement();
    this.isOpen = true;
  }

  close(e) {
    e.preventDefault();
    e.stopPropagation();

    if (!this.isOpen) {
      return;
    }

    anime({
      targets: this.overlayer,
      opacity: 0,
      duration: 200,
      easing: 'easeInExpo',
      complete: () => {
        this.root.removeChild(this.overlayer);

        if (this.overlayerParent) {
          this.overlayerParent.removeAttribute('style');
        } else {
          document.body.classList.remove('no-scroll');
        }

        this.isOpen = false;
      },
    });
  }

  createElement() {
    this.overlayer = document.createElement('div');
    this.overlayer.style.opacity = 0;
    this.overlayer.classList.add('u-mosaic__picture__fullscreen');

    const img = document.createElement('img');
    img.src = this.src;
    img.srcset = this.srcset;

    const button = document.createElement('button');
    // button.addEventListener('click', this.close);

    this.overlayer.appendChild(img);
    this.overlayer.appendChild(button);
    this.root.appendChild(this.overlayer);

    this.overlayer.addEventListener('click', this.close);
    button.focus();

    anime({
      targets: this.overlayer,
      opacity: [0, 1],
      duration: 800,
      easing: 'easeOutExpo',
    });
  }

  onKeyUp(e) {
    if (this.isOpen && e.key === 'Escape') {
      this.close(e);
    } else if (this.isOpen && e.key === 'Tab') {
      this.button.focus();
    }
  }

  destroy() {
    window.removeEventListener('keyup', this.onKeyUp);
  }
}
